export default {
  state: {
    videoData: false,
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setvideo(state, data) {
      state.videoData = data;
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    videoChange({ commit }, value) {
      commit("clearError");
      commit("setLoading", true);
      commit("setvideo", value);
    },
  },
};
